import { render } from "./CrossCircle.svg?vue&type=template&id=dba97fce"
const script = {}
script.render = render

export default script